export default class SectionBgColor {
  constructor() {
    // header
    this.header = document.querySelector('.p-header');
    // story
    this.story = document.querySelector('.p-story');
    // 各セクション
    this.act1 = document.querySelector('.p-storySection--act1');
    this.act2 = document.querySelector('.p-storySection--act2');
    this.act3 = document.querySelector('.p-storySection--act3');
    // 各セクションの最初のコンテンツ
    this.act1Cont = document.querySelector('.js-act1');
    this.act2Cont = document.querySelector('.js-act2');
    this.act3Cont = document.querySelector('.js-act3');
    // gnav
    this.headerNavBtn = document.querySelector('.js-headerNavBtn');
    this.gnav = document.querySelector('.js-gnav');
    this.init();
  }
  scrollAction() {
    // 各セクション topからの距離
    let act1Pos = this.act1.offsetTop;
    let act2Pos = this.act2.offsetTop;
    let act3Pos = this.act3.offsetTop;
    // 各セクション 最初のコンテンツの距離
    let act1ContPos = this.act1Cont.offsetTop;
    let act2ContPos = this.act2Cont.offsetTop;
    let act3ContPos = this.act3Cont.offsetTop;
    // スクロール量
    let scroll = window.pageYOffset;
    // 各セクション高さ - ウインドウの高さ
    let pos1 = act1Pos - window.innerHeight;
    let pos2 = act2Pos - window.innerHeight;
    let pos3 = act3Pos - window.innerHeight;
    let section1 = () => {
      if(scroll > pos1 + act1ContPos) {
        document.body.classList.add('is-color--act1');
      } else {
        document.body.classList.remove('is-color--act1');
      }
    }
    let section2 = () => {
      if(scroll > pos2 + act2ContPos) {
        document.body.classList.add('is-color--act2');
        document.body.classList.remove('is-color--act1');
      } else {
        document.body.classList.remove('is-color--act2');
      }
    }
    let section3 = () => {
      if(scroll > pos3 + act3ContPos) {
        document.body.classList.remove('is-color--act2');
      } else {
        section1();
        section2();
      }
    }
    section3();
  }
  gnavAction() {
    if(document.body.classList.contains('is-color--act1')) {
      document.body.style.backgroundColor = '#1d1d1d';
      document.body.classList.add('is-change-act1');
      this.gnav.classList.add('is-change-act1');
    } else {
      document.body.style.backgroundColor = null;
      document.body.classList.remove('is-change-act1');
      setTimeout(() => {
        this.gnav.classList.remove('is-change-act1');
      }, 400)
    }
    if(document.body.classList.contains('is-color--act2')) {
      document.body.style.backgroundColor = '#464646';
      document.body.classList.add('is-change-act2');
      this.gnav.classList.add('is-change-act2');
    } else {
      document.body.classList.remove('is-change-act2');
      setTimeout(() => {
        this.gnav.classList.remove('is-change-act2');
      }, 400)
    }
  }
  init() {
    // スクロールアクション実行
    this.scrollAction();
    window.addEventListener('scroll', () => {
      this.scrollAction();
    }, false);

    // gnavアクション実行
    this.headerNavBtn.addEventListener('click', () => {
      this.gnavAction();
    }, false);
  }
}